<div class="card card-body flex-item tight mt-3">
  <div class="d-flex flex-row align-items-baseline panel-with-button header-row">
    <h5 class="card-title">{{formLabel}}</h5>
  </div>

  <form [formGroup]="formGroup">
    <table class="table table-striped">
      <tbody>
      <tr>
        <td [ngClass]="{
            'app-text-danger': invalid('year')
          }"
        >Year</td>
        <td>
          <input 
            formControlName="year" 
            class="float-right" 
            type="number" 
            inputmode="numeric" 
            min="0"
            [ngClass]="{
              'is-invalid': invalid('year')
            }"
          />
        </td>
      </tr>
      <tr>
        <td [ngClass]="{
            'app-text-danger': invalid('make')
          }"
        >Make</td>
        <td>
          <input 
            formControlName="make" 
            class="float-right" 
            type="text" 
            [maxlength]="REQS.maxLength.standard"
            [ngClass]="{
              'is-invalid': invalid('make')
            }"
          />
        </td>
      </tr>
      <tr>
        <td [ngClass]="{
            'app-text-danger': invalid('model')
          }"
        >Model</td>
        <td>
          <input
            formControlName="model"
            class="float-right"
            type="text"
            [maxlength]="REQS.maxLength.standard"
            [ngClass]="{
              'is-invalid': invalid('model')
            }"
          />
        </td>
      </tr>
      <tr>
        <td>Valuation</td>
        <td>
          <input
            formControlName="tradeEstimate"
            class="float-right"
            type="number"
            inputmode="numeric"
            min="0"
            (blur)="emitTradeInValueChange()"
          /></td>
      </tr>
      <tr>
        <td>Pay off estimate</td>
        <td>
          <input
            formControlName="payOffEstimate"
            class="float-right"
            type="number"
            inputmode="numeric"
            min="0"
            (blur)="emitTradeInValueChange()"
          /></td>
      </tr>
      </tbody>
    </table>
  </form>
</div>
